import type { OptionDB } from "@project/emerge";
import { Sides } from "@project/emerge-types";
import { Covers } from "../enum/Covers";
import { LTProducts } from "../enum/LTProducts";
import type { FlightCaseSettings } from "../interfaces/FlightCaseSettings";
import { FlightCaseDefinition } from "../products/FlightCaseDefinition";
import {
  createCoverOptions,
  createRackInterior,
} from "../structure/RackInterior";

export class LCase extends FlightCaseDefinition {
  public static getSerializedDefaultVersion(
    optionDb: OptionDB,
    options?: {
      alternativeCuts: boolean;
    },
  ): FlightCaseSettings {
    const result: FlightCaseSettings =
      FlightCaseDefinition.getSerializedDefaultVersion(optionDb);
    result.type = LTProducts.LCase;
    result.exteriorOptions.inlineCover = true;
    result.exteriorOptions.strength = 6.5;
    result.variableOptions = [];
    result.cuts = options?.alternativeCuts
      ? [
          {
            offset: 50,
            reference: Sides.FRONT,
            groupName: Covers.FRONT_COVER,
          },
          {
            cutFrom: Sides.BACK,
            offset: 50,
            reference: Sides.TOP,
            groupName: Covers.TOP_COVER,
          },
        ]
      : [
          {
            offset: 50,
            reference: Sides.TOP,
            groupName: Covers.TOP_COVER,
          },
          {
            cutFrom: Sides.BOTTOM,
            offset: 50,
            reference: Sides.FRONT,
            groupName: Covers.FRONT_COVER,
          },
        ];
    result.interiorOptions = createRackInterior();
    result.coverPaddings = createCoverOptions(result.cuts);
    return result;
  }
}
